// extracted by mini-css-extract-plugin
export var boxItems = "_1r-1";
export var boxItemsLg = "_1r-2";
export var button = "_1r-7";
export var buttonLg = "_1r-8";
export var filterGroupBox = "_1r-0";
export var icon = "_1r-3";
export var iconSecondary = "_1r-6";
export var iconWrapper = "_1r-4";
export var iconWrapperLg = "_1r-5";